<template>
  <div class="py-3">
    <a-form :form="form" @submit="handleSubmit">
      <div class="row">
        <div class="col-12">
          <p class="pb-3 mb-0 font-italic font-weight-bold text-danger">Make sure to enter a valid phone number (also email if available), in order to receive your applicantion id and password.</p>
        </div>
        <div class="col-md-12">
          <a-form-item label="Full Name" class="mb-2">
            <a-input
              placeholder="Full Name"
              v-decorator="['student_first_name', { rules: [{ required: true, message: 'Please input your full name' }]}]"
            />
          </a-form-item>
        </div>
        <div class="col-md-12" v-show="false">
          <a-form-item label="Last Name" class="mb-2">
            <a-input
              placeholder="Last Name"
              v-decorator="['student_last_name', { rules: [{ required: true, message: 'Please input your last name' }], initialValue: '.'}]"
            />
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Date of birth" class="mb-2">
            <a-date-picker
              v-decorator="[
              'dob',
              {rules: [{ required: true, message: 'Please input date of birth' }]},
              ]"
              :disabled-date="disabledDate"
              :format=dateFormat />
            </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Gender" class="mb-2">
            <a-radio-group
              v-decorator="[
                'gender',
                {rules: [{ required: false, message: 'Please select a gender!' }],
                initialValue: 'M'},
              ]"
            >
              <a-radio v-for="genderType in genderTypes" :value="genderType.value" :key="genderType.value" class="mr-2">
                <span class="text-bold">{{genderType.name}}</span>
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Student Phone">
              <a-input
                placeholder="Phone"
                v-decorator="['contact_phone', {rules: [{ required: true, message: 'Please input a valid phone!', pattern: new RegExp(`^[0-9]{7,14}$`) }]}]"
                width="100%"
              >
              <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'contact_country_code',
                    { initialValue: '91' }
                  ]"
                  style="width: 70px"
                >
                  <a-select-option v-for="countryCode in countryCodes" :value="countryCode.value" :key="countryCode.value">
                    <span class="text-bold">{{countryCode.name}}</span>
                  </a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
        </div>
        <div class="col-md-6">
          <a-form-item label="Student Email" class="mb-2">
            <a-input
              placeholder="Email"
              v-decorator="['contact_email', { rules: [{ required: true, message: 'Please input a valid email!', pattern: new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$')}]}]"
            />
          </a-form-item>
        </div>
      </div>
      <hr>
      <a-button
        type="primary"
        htmlType="submit"
        size="large"
        class="text-center btn btn-primary w-50 font-weight-bold font-size-18 mt-2"
      >Register</a-button>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import store from '@/store'
import { mapState } from 'vuex'
import { genderTypes, countryCodes } from '@/services/globaldata'

export default {
  name: 'ApplicationRegister',
  props: ['schoolId', 'formId'],
  mounted: function() {
    this.loading = true
  },
  computed: {
    ...mapState(['user']),
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      school: {},
      loading: true,
      dateFormat: 'DD-MM-YYYY',
      genderTypes,
      countryCodes,
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current > moment().endOf('day')
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          let formData = values
          formData.dob = moment(values.dob).format('YYYY-MM-DD')
          this.$http.post(`/api/application-form/register/${this.formId}`, formData)
            .then(async ({ data }) => {
              this.$nprogress.done()
              if (data.data) {
                localStorage.setItem('applicant_id', data.data.id)
                localStorage.setItem('app_form_token', data.data.token)
                await store.commit('UPDATE_APPLICANT_ID', { id: data.data.id })
                await store.commit('UPDATE_APP_FORM_TOKEN', { token: data.data.token })
                this.$notification['success']({
                  message: 'Logged In',
                  description: 'You have successfully logged in!',
                })
              } else if (data.type === 'error') {
                this.$neoNotify.error(data)
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>

<style>

</style>
